import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import {
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button
} from "reactstrap";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { spinnerService } from "@chevtek/react-spinners";
import gql from "graphql-tag";
import { getDefect } from "../../data/customQueries";
import { getCustomerTeam } from "../../graphql/queries";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class DefectDetail extends React.Component {
  state = {
    start: 0,
    end: 10,
    data: {},
    open: false,
    modelData: {},
    modelTitle: ""
  };
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  getData = async id => {
    try {
      spinnerService.show("mySpinner");
      const { client, user } = this.props;
      const data = (await client.query({
        query: gql(getDefect),
        fetchPolicy: `network-only`,
        variables: { id }
      })).data.getDefect;
      this.setState({ data });
      spinnerService.hide("mySpinner");
    } catch (error) {
      spinnerService.hide("mySpinner");
    }
  };

  componentDidMount() {
    this.getData(this.props.match.params.dId);
  }
  getCustomerTeamData = async (id, title) => {
    try {
      const { client, user } = this.props;

      const data = (await client.query({
        query: gql(getCustomerTeam),
        fetchPolicy: `network-only`,
        variables: { id }
      })).data.getCustomerTeam;
      this.setState({
        open: true,
        modelData: data !== null ? data : {},
        modelTitle: title
      });
    } catch (error) { }
  };

  render() {
    const { classes } = this.props;
    let { start, data, modelData, modelTitle } = this.state;
    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={10} md={10} justify="center">
            <Card>
              <CardHeader style={{ backgroundColor: "black", radius: "15px" }}>
                <h4 className={classes.cardTitleWhite}>Defect Data</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is Defect Detail
                </p>
              </CardHeader>
              <CardBody>
                <Table>
                  <tbody>
                    <tr>
                      <th>Defect Type</th>
                      <td>{data.defectType}</td>
                      <th>Red Tag</th>
                      <td>{data.redTag ? "true" : "false"}</td>
                    </tr>
                    <tr>
                      <th>Priority</th>
                      <td>{data.priority}</td>
                      <th>Status</th>
                      <td>{data.status}</td>
                    </tr>
                    <tr>
                      <th>Reported By</th>
                      <td
                        onClick={() =>
                          this.getCustomerTeamData(
                            data.reportedByUserId,
                            "Customer Team"
                          )
                        }
                      >
                        <u style={{ cursor: "pointer", color: "blue" }}>
                          {data.reportedByUserId}
                        </u>
                      </td>
                      <th>Reported At</th>
                      <td>{data.reportedDateTime}</td>
                    </tr>
                    <tr>
                      <th>Defect Source</th>
                      <td>{data.sourceType}</td>
                      <th>Assigned To</th>
                      <td
                        onClick={() =>
                          this.getCustomerTeamData(
                            data.assignedToUserId,
                            "Customer Team"
                          )
                        }
                      >
                        {data.assignedToUserId}
                      </td>
                    </tr>
                    <tr>
                      <th>Assigned At</th>
                      <td>{data.assignedAtDateTime}</td>
                      <th>Assigned By</th>
                      <td
                        onClick={() =>
                          this.getCustomerTeamData(
                            data.assignedByUserId,
                            "Customer Team"
                          )
                        }
                      >
                        {data.assignedByUserId}
                      </td>
                    </tr>
                    {data.repairedByUserId && (
                      <tr>
                        <th>Repaired By</th>
                        <td
                          onClick={() =>
                            this.getCustomerTeamData(
                              data.repairedByUserId,
                              "Customer Team"
                            )
                          }
                        >
                          {data.repairedByUserId}
                        </td>
                        <th>Repaired At</th>
                        <td>{data.repairedDateTime}</td>
                      </tr>
                    )}{" "}
                    <tr>
                      {data.repairNotes && (
                        <React.Fragment>
                          <th>Repair Notes</th>
                          <td>{data.repairNotes}</td>
                        </React.Fragment>
                      )}
                      {data.partsUsedInRepair && (
                        <React.Fragment>
                          <th>Parts Used</th>
                          <td>{data.partsUsedInRepair}</td>
                        </React.Fragment>
                      )}
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col sm={{ size: 12 }}>
                    <Link
                      to={{
                        pathname:
                          "/defects/work/order/" + this.props.match.params.dId,
                        state: { description: data.defectDesc }
                      }}
                    >
                      <Button className={classes.blackButton}>
                        Create WorkOrder
                      </Button>
                    </Link>{" "}
                    <Button
                      color="link"
                      style={{ color: "black", fontWeight: "bold" }}
                      onClick={() => this.props.history.push("/defects")}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </GridItem>
          <Modal
            isOpen={this.state.open}
            toggle={() => this.setState({ open: !this.state.open })}
          >
            <ModalHeader>{modelTitle}</ModalHeader>
            <ModalBody>
              <Row>
                <Col sm={6}>Employee Name</Col>
                <Col sm={6}>{modelData.empName}</Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col sm={6}>Employee Email</Col>
                <Col sm={6}>{modelData.email}</Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col sm={6}>Employee Type</Col>
                <Col sm={6}>{modelData.empType}</Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col sm={6}>Employee Phone</Col>
                <Col sm={6}>{modelData.phoneNo}</Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => this.setState({ open: false })}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </GridContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile,
    vehicleGrid: state.vehicles.vehicleGrid
  };
};
export default DefectDetail = connect(mapStateToProps)(
  withStyles(styles)(DefectDetail)
);



// WEBPACK FOOTER //
// ./src/views/Defects/defectDetail.jsx